module.exports = __webpack_public_path__ + "static/h2-2dbe698aaee8dda012c3f01490ae71c0.gif";